import { ActionButtons, SelectField } from '@dispatch/web/ui';
import { Grid } from '@mui/material';
import { useFieldArray } from 'react-hook-form';
import { TaskFormComponentProps } from '@dispatch/shared/types';

export const TaskDuration = ({
  control,
  errors,
  name,
  options = [],
}: TaskFormComponentProps) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name,
  });

  return (
    <div
      style={{ display: 'flex', alignItems: 'flex-start', width: '100%' }}
      data-testid="task-duration"
    >
      <div style={{ width: '100%' }}>
        {fields.map((_, index) => {
          return (
            <Grid container spacing={2} key={index} alignItems={'baseline'}>
              <Grid size={5}>
                <SelectField
                  key={index}
                  id={`durations[${index}].peril`}
                  name={`durations[${index}].peril`}
                  label="Peril"
                  control={control}
                  errors={errors}
                  error={
                    errors[name] && errors[name][index]?.perilId
                      ? errors[name][index]?.perilId?.message
                      : null
                  }
                  options={[...options]}
                />
              </Grid>
              <Grid size={6}>
                <SelectField
                  required
                  id={`durations[${index}].duration`}
                  name={`durations[${index}].duration`}
                  label="Duration"
                  control={control}
                  errors={errors}
                  error={
                    errors[name] && errors[name][index]?.duration
                      ? errors[name][index]?.duration?.message
                      : null
                  }
                  options={[
                    { title: 'S', value: 's' },
                    { title: 'M', value: 'm' },
                    { title: 'L', value: 'l' },
                  ]}
                />
              </Grid>
              <Grid alignSelf="center" size={1}>
                <ActionButtons
                  index={index}
                  fields={fields}
                  append={() => append({ perilId: '', duration: '' })}
                  remove={() => remove(index)}
                />
              </Grid>
            </Grid>
          );
        })}
      </div>
    </div>
  );
};
